/**
 * Primary pay CTA + trust copy. Trust ALWAYS sits below the button so a
 * coral halo / box-shadow / hover lift cannot eat "Pago protegido…".
 *
 * Stripe, Apple Pay sheet, and Linear all put legal copy under the command.
 */
import { View, Text, type StyleProp, type ViewStyle } from 'react-native'
import { Lock } from '@/components/ui/icons'
import { Button } from '@/components/ui/Button'
import { useTheme } from '@/lib/hooks/use-theme'
import { useSemanticColors } from '@/lib/theme/tokens'
import { FONTS, SPACING } from '@/lib/brand'

export function CheckoutPayFooter({
  title,
  onPress,
  loading,
  disabled,
  testID,
  trustText,
  errorText,
  errorTestID,
  hintText,
  style,
}: {
  title: string
  onPress: () => void
  loading?: boolean
  disabled?: boolean
  testID: string
  trustText: string
  errorText?: string | null
  errorTestID?: string
  hintText?: string | null
  style?: StyleProp<ViewStyle>
}) {
  const { isDark } = useTheme()
  const colors = useSemanticColors(isDark)

  return (
    <View style={[{ gap: SPACING.sm, overflow: 'visible' }, style]} testID={`${testID}-footer`}>
      {errorText ? (
        <Text
          style={{
            fontFamily: FONTS.body,
            fontSize: 14,
            lineHeight: 20,
            color: colors.textError,
          }}
          testID={errorTestID}
        >
          {errorText}
        </Text>
      ) : null}

      <Button
        title={title}
        variant="primary"
        size="lg"
        loading={loading}
        disabled={disabled}
        onPress={onPress}
        testID={testID}
      />

      <View
        style={{
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'center',
          gap: SPACING.xs,
          paddingTop: SPACING.xs,
        }}
        testID={`${testID}-trust`}
      >
        <Lock size={13} color={colors.textMuted} strokeWidth={1.8} />
        <Text
          style={{
            flex: 1,
            fontFamily: FONTS.body,
            fontSize: 12,
            lineHeight: 17,
            color: colors.textMuted,
          }}
        >
          {trustText}
        </Text>
      </View>

      {hintText ? (
        <Text
          style={{
            fontFamily: FONTS.body,
            fontSize: 12,
            lineHeight: 17,
            color: colors.textSecondary,
            textAlign: 'center',
          }}
          testID={`${testID}-fee-hint`}
        >
          {hintText}
        </Text>
      ) : null}
    </View>
  )
}
